module.exports = __webpack_public_path__ + "static/media/backArrow.df873233.svg";